import { handleActions } from 'redux-actions';
import Immutable from 'immutable';

const initState = Immutable.fromJS({
  formBean: {
    orderId: null,
    outputFile: '',
    outputFile2: ''
  },
  formBeanValidation: {},
  alertStyle: null,
  alertMessage: null,

  allOrderIds: []
});

const downloadItemsReducer = handleActions({
  CHANGE_DOWNLOAD_ITEMS_VALUE: (state, { payload }) => {
    let formBean = state.get('formBean');
    return state.merge({
      formBean: formBean.set(payload.id, payload.value),
    });
  },
  BEFORE_GENERATE_DOWNLOAD_ITEMS: (state, { payload }) => {
    return state.merge({
      formBean: {
        outputFile: '',
        outputFile2: ''
      },
      alertStyle: null,
      alertMessage: '資料處理中，請稍後。'
    });
  },
  AFTER_GENERATE_DOWNLOAD_ITEMS: (state, { payload }) => {
    // open pdf file automatically
    // if (payload.data.bean.outputFile !== '') {
    //   window.open(payload.data.bean.outputFile);
    // }
    // change state
    return state.merge({
      formBean: payload.data.bean,
      formBeanValidation: payload.data.valBean,
      alertStyle: payload.data.alertStyle,
      alertMessage: payload.data.alertMessage
    });
  },
  CLEAN_DOWNLOAD_ITEMS_ALERT: (state, { payload }) => {
    return state.merge({
      alertStyle: null,
      alertMessage: null,
      formBean: {
        orderId: null,
        outputFile: '',
        outputFile2: ''
      },
      formBeanValidation: {}
    })
  },
  FIND_ORDERS_WITH_SHIPMENT: (state, { payload }) => {
    return state.merge({
      allOrderIds: payload.data
    })
  }
}, initState);

export default downloadItemsReducer;


// WEBPACK FOOTER //
// ./src/reducers/downloadItemsReducer.js